<template>
  <div id="flujosAprobacion">
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Flujos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <v-btn slot="activator" :loading="loading" icon @click="newFlow()">
            <v-icon>add_box</v-icon>
          </v-btn>
          <span>Nuevo Flujo</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="flujos" :loading="loading" :search="search"
      rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetailFlow(props.item.id)">{{ props.item.nombre }}</td>
          <td class="text-xs-center" @click="showDetailFlow(props.item.id)">{{ props.item.tipo }}</td>
          <td class="text-xs-center" @click="showDetailFlow(props.item.id)">{{ props.item.no_asignados }}</td>
          <td class="text-xs-center" @click="showDetailFlow(props.item.id)">{{ props.item.fecha_registro }}</td>
          <td class="text-xs-center" @click="showDetailFlow(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogNewFlow" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Nuevo flujo de aprobación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionFlow = true">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS GENERALES</h3><br/>
                  <v-timeline dense clipped>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">edit</v-icon>
                      <v-text-field v-model="nuevoFlujo.nombre" :error-messages="nombreErrors" flat label="Nombre"
                      @input="$v.nuevoFlujo.nombre.$touch()" @blur="$v.nuevoFlujo.nombre.$touch()">
                      </v-text-field>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">insert_drive_file</v-icon>
                      <v-select v-model="nuevoFlujo.tipo" :error-messages="tipoErrors" :items="tipos"
                      @input="$v.nuevoFlujo.tipo.$touch()" @blur="$v.nuevoFlujo.tipo.$touch()" item-text="descripcion"
                      item-value="id" label="Tipo"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">business</v-icon>
                      <v-select v-model="nuevoFlujo.empresa" :error-messages="empresaErrors" :items="catalogos.empresas"
                      @input="$v.nuevoFlujo.empresa.$touch()" @blur="$v.nuevoFlujo.empresa.$touch()" item-text="descripcion"
                      item-value="id" label="Empresa"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">location_on</v-icon>
                      <v-select v-model="nuevoFlujo.direccion" :error-messages="direccionErrors" :items="catalogos.direcciones"
                      @input="$v.nuevoFlujo.direccion.$touch()" @blur="$v.nuevoFlujo.direccion.$touch()" item-text="descripcion"
                      item-value="id" label="Dirección / Área"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">person</v-icon>
                      <v-select v-model="nuevoFlujo.usuario" :items="catalogos.usuarios" item-text="nombre" item-value="id"
                      label="Usuarios disponibles" append-outer-icon="add_circle"
                      @click:append-outer="addUser()"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">star</v-icon>
                      <v-text-field v-model="nuevoFlujo.rol" :error-messages="rolErrors" flat label="Rol"
                      @input="$v.nuevoFlujo.rol.$touch()" @blur="$v.nuevoFlujo.rol.$touch()">
                      </v-text-field>
                    </v-timeline-item>
                  </v-timeline>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">USUARIOS ASIGNADOS</h3><br/>
                  <v-timeline dense clipped>
                    <v-slide-x-transition group>
                      <v-timeline-item v-for="(user, index) in nuevoFlujo.asignados" :key="user.id" class="mt-3" color="pink" small>
                        <v-layout justify-space-between>
                          <v-flex xs8>
                            <h3>{{ index + 1 }} - {{ user.nombre + ' / ' + user.rol }}</h3>
                          </v-flex>
                          <v-flex xs3 text-xs-right>
                            <h3 style="color:#607D8B;">{{ user.alias }}</h3>
                          </v-flex>
                          <v-flex xs1 text-xs-right>
                            <v-icon medium color="error" @click="removeUser(index)">cancel</v-icon>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>
                    </v-slide-x-transition>
                  </v-timeline>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetFlow" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetailFlow()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de flujo de aprobación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionDelFlow = true">Eliminar</v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionUpdFlow = true">Actualizar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS GENERALES</h3><br/>
                  <v-timeline dense clipped>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">edit</v-icon>
                      <v-text-field v-model="detalleFlujo.nombre" :error-messages="nombreErrors" flat label="Nombre"
                      @input="$v.detalleFlujo.nombre.$touch()" @blur="$v.detalleFlujo.nombre.$touch()">
                      </v-text-field>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">insert_drive_file</v-icon>
                      <v-select v-model="detalleFlujo.tipo" :error-messages="tipoErrors" :items="tipos"
                      @input="$v.detalleFlujo.tipo.$touch()" @blur="$v.detalleFlujo.tipo.$touch()" item-text="descripcion"
                      item-value="id" label="Tipo"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">business</v-icon>
                      <v-select v-model="detalleFlujo.empresa" :error-messages="empresaErrors" :items="catalogos.empresas"
                      @input="$v.detalleFlujo.empresa.$touch()" @blur="$v.detalleFlujo.empresa.$touch()" item-text="descripcion"
                      item-value="id" label="Empresa"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">location_on</v-icon>
                      <v-select v-model="detalleFlujo.direccion" :error-messages="direccionErrors" :items="catalogos.direcciones"
                      @input="$v.detalleFlujo.direccion.$touch()" @blur="$v.detalleFlujo.direccion.$touch()" item-text="descripcion"
                      item-value="id" label="Dirección / Área"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">person</v-icon>
                      <v-select v-model="detalleFlujo.usuario" :items="catalogos.usuarios" item-text="nombre" item-value="id"
                      label="Usuarios disponibles" append-outer-icon="add_circle"
                      @click:append-outer="addUserDetail()"></v-select>
                    </v-timeline-item>
                    <v-timeline-item fill-dot class="white--text" color="info" large>
                      <v-icon slot="icon" large color="white">star</v-icon>
                      <v-text-field v-model="detalleFlujo.rol" :error-messages="rolErrors" flat label="Rol"
                      @input="$v.detalleFlujo.rol.$touch()" @blur="$v.detalleFlujo.rol.$touch()">
                      </v-text-field>
                    </v-timeline-item>
                  </v-timeline>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">USUARIOS ASIGNADOS</h3><br/>
                  <v-timeline dense clipped>
                    <v-slide-x-transition group>
                      <v-timeline-item v-for="(user, index) in detalleFlujo.asignados" :key="user.id" class="mt-3" color="pink" small>
                        <v-layout justify-space-between>
                          <v-flex xs8>
                            <h3>{{ index + 1 }} - {{ user.nombre + ' / ' + user.rol }}</h3>
                          </v-flex>
                          <v-flex xs3 text-xs-right>
                            <h3 style="color:#607D8B;">{{ user.alias }}</h3>
                          </v-flex>
                          <v-flex xs1 text-xs-right>
                            <v-icon medium color="error" @click="removeUserDetail(index)">cancel</v-icon>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>
                    </v-slide-x-transition>
                  </v-timeline>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionFlow" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea guardar el flujo de aprobación?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionFlow = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="save()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionUpdFlow" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar el flujo de aprobación?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionUpdFlow = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="update()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionDelFlow" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea eliminar el flujo de aprobación?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionDelFlow = false">Cancelar</v-btn>
          <v-btn flat color="error" @click.native="remove()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import services from '@/config/services'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { maxLength, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'flujosAprobacion',
  mixins: [validationMixin],
  validations: {
    nuevoFlujo: {
      nombre: { required: requiredIf(function() { return this.isNewFlow }), maxLength: maxLength(100) },
      tipo: { required: requiredIf(function() { return this.isNewFlow }) },
      empresa: { required: requiredIf(function() { return this.isNewFlow }) },
      direccion: { required: requiredIf(function() { return this.isNewFlow }) },
      rol: { maxLength: maxLength(50) }
    },
    detalleFlujo: {
      nombre: { required: requiredIf(function() { return !this.isNewFlow }), maxLength: maxLength(100) },
      tipo: { required: requiredIf(function() { return !this.isNewFlow }) },
      empresa: { required: requiredIf(function() { return !this.isNewFlow }) },
      direccion: { required: requiredIf(function() { return !this.isNewFlow }) },
      rol: { maxLength: maxLength(50) }
    }
  },
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: '',
    msgError: '',
    dialogNewFlow: false,
    dialogDetFlow: false,
    questionFlow: false,
    questionUpdFlow: false,
    questionDelFlow: false,
    search: '',
    pagination: {
      rowsPerPage: 7
    },
    headers: [
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Tipo', align: 'center', sortable: false, value: 'tipo' },
      { text: 'No. Asignados', align: 'center', sortable: false, value: 'no_asignados' },
      { text: 'Fecha de Registro', align: 'center', sortable: false, value: 'fecha_registro' },
      { text: 'Fecha de Actualización', align: 'center', sortable: false, value: 'fecha_actualizacion' }
    ],
    tipos: [{
      id: 'caja_chica',
      descripcion: 'Caja chica'
    },
    {
      id: 'reposicion',
      descripcion: 'Reposición'
    },
    {
      id: 'gastos_viaje',
      descripcion: 'Gastos de viaje (Anticipos)'
    },
    {
      id: 'gastos_viaje_comprobantes',
      descripcion: 'Gastos de viaje (Comprobantes)'
    },
    {
      id: 'gastos_amex_solicitud',
      descripcion: 'Gastos AMEX (Solicitud)'
    },
    {
      id: 'gastos_amex_comprobacion',
      descripcion: 'Gastos AMEX (Comprobación)'
    },
    {
      id: 'gastos_representacion_solicitud',
      descripcion: 'Gastos Representación (Solicitud)'
    }
    ,
    {
      id: 'gastos_representacion_comprobacion',
      descripcion: 'Gastos Representación (Comprobación)'
    }],
    catalogos: {
      empresas: [],
      direcciones: [],
      usuarios: []
    },
    options: {
      group: 'users'
    },
    flujos: [],
    nuevoFlujo: {
      nombre: '',
      tipo: '',
      empresa: '',
      direccion: '',
      usuario: '',
      rol: '',
      asignados: []
    },
    detalleFlujo: {
      id: '',
      nombre: '',
      tipo: '',
      empresa: '',
      direccion: '',
      usuario: '',
      rol: '',
      asignados: []
    }
  }),
  mounted() {
    this.refresh()
  },
  computed: {
    nombreErrors() {
      const errors = []
      if (!this.$v.nuevoFlujo.nombre.$dirty) return errors
      this.dialogNewFlow && !this.$v.nuevoFlujo.nombre.maxLength && errors.push('El campo excede la longitud máxima')
      this.dialogNewFlow && !this.$v.nuevoFlujo.nombre.required && errors.push('El campo es obligatorio')
      !this.dialogNewFlow && !this.$v.detalleFlujo.nombre.maxLength && errors.push('El campo excede la longitud máxima')
      !this.dialogNewFlow && !this.$v.detalleFlujo.nombre.required && errors.push('El campo es obligatorio')
      return errors
    },
    tipoErrors() {
      const errors = []
      if (!this.$v.nuevoFlujo.tipo.$dirty) return errors
      this.dialogNewFlow && !this.$v.nuevoFlujo.tipo.required && errors.push('El campo es obligatorio')
      !this.dialogNewFlow && !this.$v.detalleFlujo.tipo.required && errors.push('El campo es obligatorio')
      return errors
    },
    empresaErrors() {
      const errors = []
      if (!this.$v.nuevoFlujo.empresa.$dirty) return errors
      this.dialogNewFlow && !this.$v.nuevoFlujo.empresa.required && errors.push('El campo es obligatorio')
      !this.dialogNewFlow && !this.$v.detalleFlujo.empresa.required && errors.push('El campo es obligatorio')
      return errors
    },
    direccionErrors() {
      const errors = []
      if (!this.$v.nuevoFlujo.direccion.$dirty) return errors
      this.dialogNewFlow && !this.$v.nuevoFlujo.direccion.required && errors.push('El campo es obligatorio')
      !this.dialogNewFlow && !this.$v.detalleFlujo.direccion.required && errors.push('El campo es obligatorio')
      return errors
    },
    rolErrors() {
      const errors = []
      if (!this.$v.nuevoFlujo.nombre.$dirty) return errors
      this.dialogNewFlow && !this.$v.nuevoFlujo.rol.maxLength && errors.push('El campo excede la longitud máxima')
      !this.dialogNewFlow && !this.$v.detalleFlujo.rol.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    },
    isNewFlow() {
      return this.dialogNewFlow
    },
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    refresh() {
      this.loading = true
      this.ws('get', 'flujosAprobacion')
        .then(res => {
          if (res.ok) {
            this.flujos = res.data.flujos
          }
          else {
            this.flujos = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    prepareForm (data) {
      this.catalogos.empresas = data.catalogos.empresas
      this.catalogos.direcciones = data.catalogos.direcciones
    },
    prepareUsers(data) {
      this.catalogos.usuarios = data.usuarios
      this.catalogos.usuarios.unshift({
        id: 'jefe_inmediato',
        nombre: 'Jefe inmediato',
        alias: '*'
      })
      this.catalogos.usuarios.unshift({
        id: '',
        nombre: 'Seleccionar...',
        alias: ''
      })
      this.dialogNewFlow = true
    },
    newFlow() {
      this.loading = true
      this.ws('get', 'detalleUsuario')
        .then(res => {
          if (res.ok) {
            this.prepareForm(res.data)
            this.ws('get', 'usuarios')
              .then(res => {
                if (res.ok) {
                  this.prepareUsers(res.data)
                }
                else {
                  this.error = true
                  this.msgError = res.message
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
          else {
            this.error = true
            this.msgError = res.message
            this.loading = false
          }
        })
    },
    addUser() {
      if (this.nuevoFlujo.usuario !== '') {
        if (this.nuevoFlujo.rol !== '') {
          for (let i = 1; i < this.catalogos.usuarios.length; i++) {
            if (this.catalogos.usuarios[i].id == this.nuevoFlujo.usuario) {
              this.nuevoFlujo.asignados.push({
                id: this.catalogos.usuarios[i].id,
                nombre: this.catalogos.usuarios[i].nombre,
                alias: this.catalogos.usuarios[i].alias,
                rol: this.nuevoFlujo.rol
              });
              this.catalogos.usuarios.splice(i, 1)
              this.nuevoFlujo.usuario = ''
              this.nuevoFlujo.rol = ''
            }
          }
        }
        else {
          this.error = true
          this.msgError = 'Debe agregar un rol para el usuario'
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un usuario'
      }
    },
    removeUser(idx) {
      this.catalogos.usuarios.push({
        id: this.nuevoFlujo.asignados[idx].id,
        nombre: this.nuevoFlujo.asignados[idx].nombre,
        alias: this.nuevoFlujo.asignados[idx].alias
      })
      this.nuevoFlujo.asignados.splice(idx, 1)
    },
    close() {
      this.$v.$reset()
      this.catalogos = {
        empresas: [],
        direcciones: [],
        usuarios: []
      }
      this.nuevoFlujo = {
        nombre: '',
        tipo: '',
        empresa: '',
        direccion: '',
        usuario: '',
        rol: '',
        asignados: []
      }
      this.dialogNewFlow = false
    },
    save() {
      this.questionFlow = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.nuevoFlujo.asignados.length >= 1) {
          if (this.nuevoFlujo.asignados.length <= 100) {
            this.loading = true
            let asignados = []
            let roles = []
            for (let i = 0; i < this.nuevoFlujo.asignados.length; i++) {
              asignados.push(this.nuevoFlujo.asignados[i].id)
              roles.push(this.nuevoFlujo.asignados[i].rol)
            }
            let data = {
              nombre: this.nuevoFlujo.nombre,
              tipo: this.nuevoFlujo.tipo,
              empresa: this.nuevoFlujo.empresa,
              direccion: this.nuevoFlujo.direccion,
              asignados: asignados,
              roles: roles
            }
            this.ws('post', 'nuevoFlujoAprobacion', data)
              .then(res => {
                if (res.ok) {
                  this.close()
                  this.refresh()
                  this.success = true
                  this.msgSuccess = res.message
                }
                else {
                  this.error = true
                  this.msgError = res.message
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
          else {
            this.error = true
            this.msgError = 'Ha excedido el límite de usuarios asignados'
          }
        }
        else {
          this.error = true
          this.msgError = 'Debe asignar al menos un usuario'
        }
      }
    },
    prepareDetailForm (data) {
      this.catalogos.empresas = data.catalogos.empresas
      this.catalogos.direcciones = data.catalogos.direcciones
    },
    prepareDetailUsers(data) {
      this.catalogos.usuarios = data.usuarios
      this.catalogos.usuarios.unshift({
        id: 'jefe_inmediato',
        nombre: 'Jefe inmediato',
        alias: '*'
      })
      this.catalogos.usuarios.unshift({
        id: '',
        nombre: 'Seleccionar...',
        alias: ''
      })
    },
    showDetailFlow(id) {
      this.loading = true
      this.ws('get', 'detalleUsuario')
        .then(res => {
          if (res.ok) {
            this.prepareDetailForm(res.data)
            this.ws('get', 'usuarios')
              .then(res => {
                if (res.ok) {
                  this.prepareDetailUsers(res.data)
                  this.ws('get', 'detalleFlujoAprobacion', { id })
                    .then(res => {
                      if (res.ok) {
                        this.detalleFlujo.id = res.data.flujo.id
                        this.detalleFlujo.nombre = res.data.flujo.nombre
                        this.detalleFlujo.tipo = res.data.flujo.tipo
                        this.detalleFlujo.empresa = res.data.flujo.empresa
                        this.detalleFlujo.direccion = res.data.flujo.direccion
                        for (let i = 0; i < res.data.asignados.length; i++) {
                          for (let j = 0; j < this.catalogos.usuarios.length; j++) {
                            if (res.data.asignados[i].id == this.catalogos.usuarios[j].id) {
                              this.catalogos.usuarios.splice(j, 1)
                              j = -1
                            }
                          }
                        }
                        this.detalleFlujo.asignados = res.data.asignados
                        this.dialogDetFlow = true
                      }
                      else {
                        this.error = true
                        this.msgError = res.message
                      }
                    })
                    .finally(() => {
                      this.loading = false
                    })
                }
                else {
                  this.error = true
                  this.msgError = res.message
                  this.loading = false
                }
              })
          }
          else {
            this.error = true
            this.msgError = res.message
            this.loading = false
          }
        })
    },
    addUserDetail() {
      if (this.detalleFlujo.usuario !== '') {
        if (this.detalleFlujo.rol !== '') {
          for (let i = 1; i < this.catalogos.usuarios.length; i++) {
            if (this.catalogos.usuarios[i].id == this.detalleFlujo.usuario) {
              this.detalleFlujo.asignados.push({
                id: this.catalogos.usuarios[i].id,
                nombre: this.catalogos.usuarios[i].nombre,
                alias: this.catalogos.usuarios[i].alias,
                rol: this.detalleFlujo.rol
              });
              this.catalogos.usuarios.splice(i, 1)
              this.detalleFlujo.usuario = ''
              this.detalleFlujo.rol = ''
            }
          }
        }
        else {
          this.error = true
          this.msgError = 'Debe agregar un rol para el usuario'
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un usuario'
      }
    },
    removeUserDetail(idx) {
      this.catalogos.usuarios.push({
        id: this.detalleFlujo.asignados[idx].id,
        nombre: this.detalleFlujo.asignados[idx].nombre,
        alias: this.detalleFlujo.asignados[idx].alias,
      })
      this.detalleFlujo.asignados.splice(idx, 1)
    },
    closeDetailFlow() {
      this.$v.$reset()
      this.catalogos = {
        empresas: [],
        direcciones: [],
        usuarios: []
      }
      this.detalleFlujo = {
        id: '',
        nombre: '',
        tipo: '',
        empresa: '',
        direccion: '',
        usuario: '',
        rol: '',
        asignados: []
      }
      this.dialogDetFlow = false
    },
    update() {
      this.questionUpdFlow = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.detalleFlujo.asignados.length >= 1) {
          if (this.detalleFlujo.asignados.length <= 100) {
            this.loading = true
            let asignados = []
            let roles = []
            for (let i = 0; i < this.detalleFlujo.asignados.length; i++) {
              asignados.push(this.detalleFlujo.asignados[i].id)
              roles.push(this.detalleFlujo.asignados[i].rol)
            }
            let data = {
              id: this.detalleFlujo.id,
              nombre: this.detalleFlujo.nombre,
              tipo: this.detalleFlujo.tipo,
              empresa: this.detalleFlujo.empresa,
              direccion: this.detalleFlujo.direccion,
              asignados: asignados,
              roles: roles
            }
            this.ws('post', 'actualizarFlujoAprobacion', data)
              .then(res => {
                if (res.ok) {
                  this.closeDetailFlow()
                  this.refresh()
                  this.success = true
                  this.msgSuccess = res.message
                }
                else {
                  this.error = true
                  this.msgError = res.message
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
          else {
            this.error = true
            this.msgError = 'Ha excedido el límite de usuarios asignados'
          }
        }
        else {
          this.error = true
          this.msgError = 'Debe asignar al menos un usuario'
        }
      }
    },
    remove() {
      this.questionDelFlow = false
      this.$v.$touch()
      this.loading = true
      let data = {
        id: this.detalleFlujo.id
      }
      this.ws('post', 'eliminarFlujoAprobacion', data)
        .then(res => {
          if (res.ok) {
            this.closeDetailFlow()
            this.refresh()
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
